import { render } from "./AboutHistoryBackground.vue?vue&type=template&id=561d21c4&scoped=true"
import script from "./AboutHistoryBackground.vue?vue&type=script&lang=js"
export * from "./AboutHistoryBackground.vue?vue&type=script&lang=js"

import "./AboutHistoryBackground.vue?vue&type=style&index=0&id=561d21c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561d21c4"]])

export default __exports__